import { object, array, any, safeParse } from 'zod';

export function checkTablaDefDataFromApi(data: Record<string, unknown>) {
  const responseSchema = object({
    Messages: array(any()).optional(),
    col: array(any()),
    dEmple: array(any()),
    fil: array(any()),
  });

  const parsedData = safeParse(responseSchema, data);

  if (!parsedData.success) {
    return responseSchema.encode({ col: [], dEmple: [], fil: [] });
  }

  return parsedData.data;
}
